const React = require('react');

module.exports = ({className, children}) => (
  <span className={
    `dB f16 fw7 lh23 ttU`
    + (className ? ` ${className}` : '')
  }>
    {children}
  </span>
)